export enum PaymentStatus {
  Unpaid = 0,
  PartiallyPaid = 1,
  FullyPaid = 2,
  Overpaid = 3
}

export interface PaymentTransaction {
  id: string;
  amount: number;
  paymentMethod: string;
  transactionReference?: string;
  notes?: string;
  recordedBy: string;
  paymentDate: string;
  createdAt: string;
}

export interface RecordPaymentRequest {
  amount: number;
  paymentMethod: string;
  transactionReference?: string;
  notes?: string;
  paymentDate: string;
}

export interface RecordPaymentResponse {
  paymentId: string;
  newTotalPaid: number;
  remainingBalance: number;
  paymentStatus: PaymentStatus;
}

export interface PaymentHistoryResponse {
  registrationId: string;
  appliedFee: number;
  totalPaid: number;
  remainingBalance: number;
  paymentStatus: PaymentStatus;
  payments: PaymentTransaction[];
}

export interface PaymentSummaryResponse {
  tournamentId: string;
  tournamentName: string;
  teamSummary: TeamPaymentSummary;
  individualSummary: IndividualPaymentSummary;
  totalExpectedRevenue: number;
  totalReceivedRevenue: number;
  totalOutstandingRevenue: number;
}

export interface TeamPaymentSummary {
  totalRegistrations: number;
  unpaidCount: number;
  partiallyPaidCount: number;
  fullyPaidCount: number;
  expectedRevenue: number;
  receivedRevenue: number;
  outstandingRevenue: number;
}

export interface IndividualPaymentSummary {
  totalRegistrations: number;
  unpaidCount: number;
  partiallyPaidCount: number;
  fullyPaidCount: number;
  expectedRevenue: number;
  receivedRevenue: number;
  outstandingRevenue: number;
}

export const PAYMENT_METHODS = [
  'Cash',
  'Card',
  'Bank Transfer',
  'Fawry',
  'InstaPay'
] as const;

export type PaymentMethod = typeof PAYMENT_METHODS[number];
